import moment from 'moment-timezone';
import { Component, OnInit, ViewChild, } from '@angular/core';
import { InputConfig,InputConfigCustom } from "@tmhcc-ng-lib/framwork/form-inputs";
import { WeatherRatingSetupService } from "./config/wuw-dashboard-config";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoaderService } from "@tmhcc-ng-lib/framwork/loader";
import { DateService } from "@tmhcc-ng-lib/framwork/services";
import { CoreInputValidationService } from '@tmhcc-ng-lib/framwork/core-inputs';

import { WtUpdateQuoteRequest, Events, Coverages, Venue, EventDay, CostResponse} from "libs/data-service/def/weather-quote";
import { WeatherQuoteService } from "libs/data-service/weather/weather-quote.service";
import { WtUpdateQuoteResponse } from "libs/models/classes/weather-quote.model";
import { CurrencyService } from "@tmhcc/framwork/services";
import { DatePickerCustomComponent } from 'libs/framwork/core-inputs/src/lib/date-picker-custom/date-picker-custom.component';

@Component({
  selector: 'wuw-dashboard',
  templateUrl: './wuw-dashboard.component.html',
  styleUrls: ['./wuw-dashboard.component.scss'],
  standalone: false
})

export class WUWDashboardComponent extends WeatherRatingSetupService implements OnInit {
  weatherRatingInfoFields: InputConfigCustom[];
  WUWRatingFormGroup: FormGroup;
  thresholdConfigInfoFields: InputConfig[];
  limitConfigInfoFields: InputConfig[];
  updateQuoteResponse: WtUpdateQuoteResponse;
  costsResponseData: CostResponse[] = [];

  @ViewChild(DatePickerCustomComponent) private childComponent!: DatePickerCustomComponent;

  constructor(
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private dataService: DateService,
    private validationService: CoreInputValidationService,
    private weatherQuoteService: WeatherQuoteService,
    private customCurrencyPipe: CurrencyService
    ) { super(dataService);}

  ngOnInit(): void {
     var element = document.getElementById("bannerCaption");
     element.innerText = "PAPI Admin - Weather"
     var dbElement = document.getElementById("dashboardHeader");
     dbElement.innerText = "PAPI-DASHBOARD";
     this.weatherRatingInfoFields = this.weatherRatingConfig().weatherRatingConfigList;
     this.thresholdConfigInfoFields = this.ThresholdConfig().ThresholdConfigList;
     this.limitConfigInfoFields = this.LimitConfig().LimitConfigList;
     this.setFormControl();
     this.CallSetEventEndDate();
  }

  setFormControl() {
     this.loaderService.show();
     const formControls = {};
     this.weatherRatingInfoFields.forEach((element: InputConfigCustom) => {
       let validators;
       if (element.config && element.config.validation) {
         validators = element.config.validation;
       } else {
         validators = null;
       }
       formControls[element.fieldInfo.fieldName] = [
         element.fieldInfo.value,
         Validators.compose(validators)
       ];
     });
     this.thresholdConfigInfoFields.forEach((element: InputConfig) => {
       let validators;
       if (element.config && element.config.validation) {
         validators = element.config.validation;
       } else {
         validators = null;
       }
       formControls[element.fieldInfo.fieldName] = [
         element.fieldInfo.value,
         Validators.compose(validators)
       ];
     });
     this.limitConfigInfoFields.forEach((element: InputConfig) => {
       let validators;
       if (element.config && element.config.validation) {
         validators = element.config.validation;
       } else {
         validators = null;
       }
       formControls[element.fieldInfo.fieldName] = [
         element.fieldInfo.value,
         Validators.compose(validators)
       ];
     });
     this.WUWRatingFormGroup = this.formBuilder.group(formControls);
     this.loaderService.hide();
   }
  AddEventDates() {
    if (this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName === "eventstartdate4").config.isHidden === true) {

      if (this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate3").config.isHidden === true) {
        if (this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate2").config.isHidden === true) {
          if (this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate1").config.isHidden === true) {
             this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate1").config.isHidden = false;
             this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventenddate1").config.isHidden = false;
             document.getElementById("btnRemoveEventDates").hidden = false;
          }
          else {
            this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate2").config.isHidden = false;
            this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventenddate2").config.isHidden = false;
          }
        }
        else {
          this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate3").config.isHidden = false;
          this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventenddate3").config.isHidden = false;
        }
      }
      else {
        this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate4").config.isHidden = false;
        this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventenddate4").config.isHidden = false;
      }
    }
  }

  CallSetEventEndDate()
  {
    for(let i = 0; i<5 ; i++)
    {
      this.SetEventEndDate(i);
    }
  }
  SetEventEndDate( i: number){
      let currentDate = new Date();
      this.weatherRatingInfoFields.forEach((element)=>{
        if(element.fieldInfo.fieldName === 'eventstartdate' + i){
          element.config.datePickerConfig.minDate = this.dataService.moment(currentDate).add(7,'d').toDate();
        }
        if(element.fieldInfo.fieldName === 'eventenddate' + i){
          element.config.datePickerConfig.minDate = this.dataService.moment(currentDate).add(7,'d').toDate();
        }
      });
  }

  RemoveEventDates() {
    if (this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName === "eventstartdate4").config.isHidden === false) {
        this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName === "eventstartdate4").config.isHidden = true;
        this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName === "eventenddate4").config.isHidden = true;
        this.WUWRatingFormGroup.get('eventstartdate4').setValue(null);
        this.WUWRatingFormGroup.get('eventenddate4').setValue(null);
    }
    else if (this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate3").config.isHidden === false) {
       this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate3").config.isHidden = true;
       this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventenddate3").config.isHidden = true;
       this.WUWRatingFormGroup.get('eventstartdate3').setValue(null);
       this.WUWRatingFormGroup.get('eventenddate3').setValue(null);
    }
    else if (this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate2").config.isHidden === false) {
       this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate2").config.isHidden = true;
       this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventenddate2").config.isHidden = true;
       this.WUWRatingFormGroup.get('eventstartdate2').setValue(null);
       this.WUWRatingFormGroup.get('eventenddate2').setValue(null);
    }
    else if (this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate1").config.isHidden === false) {
       this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventstartdate1").config.isHidden = true;
       this.weatherRatingInfoFields.find((element) => element.fieldInfo.fieldName ==="eventenddate1").config.isHidden = true;
       this.WUWRatingFormGroup.get('eventstartdate1').setValue(null);
       this.WUWRatingFormGroup.get('eventenddate1').setValue(null);
       document.getElementById("btnRemoveEventDates").hidden = true;
    }
  }
   AddThreshold(){
    let length = this.thresholdConfigInfoFields.length;
      for(let j = length-1 ; j > 0; j--)
        {
         if(this.thresholdConfigInfoFields[j].config.isHidden === true)
          {
            this.thresholdConfigInfoFields[j].config.isHidden = false;
            if(j < 2)
              document.getElementById('btnAddThreshold').style.display = 'none';
            break;
          }
        }
   }

   AddLimit(){
    let length = this.limitConfigInfoFields.length;
      for(let j = length-1 ; j > 0; j--)
        {
         if(this.limitConfigInfoFields[j].config.isHidden === true)
          {
            this.limitConfigInfoFields[j].config.isHidden = false;
            if(j < 2)
              document.getElementById('btnAddLimit').style.display = 'none';
            break;
          }
      }
   }
   onSubmit() {
    this.validationService.setFormSubmission(true);
    if (this.WUWRatingFormGroup.valid) {
      this.costsResponseData = [];
       this.loaderService.show();
       const payload = this.mapNewQuoteForm();
       this.weatherQuoteService.updateQuote(payload).subscribe(data => {
       this.loaderService.hide();
        this.updateQuoteResponse = data;
        this.updateQuoteResponse.events[0].eventDays.forEach((eventDay) => {
          eventDay.coverages[0].costs.forEach((avrcost) => {
          avrcost["limit"] = this.customCurrencyPipe.toCurrency(avrcost["limit"]);
          avrcost["cost"] = avrcost["eligible"]
            ? this.customCurrencyPipe.toCurrency(avrcost["cost"])
            : 'N/A';
          let costResponse: CostResponse;
          let eventPeriodVal = this.dataService.moment(eventDay.startDateTime).format("L")
                            + " " + this.dataService.moment(eventDay.startDateTime).format('hh:mm A')
                            + "-" +  this.dataService.moment(eventDay.endDateTime).format('hh:mm A');
          costResponse = {
            cost: avrcost["cost"],
            limit: avrcost["limit"],
            threshold: avrcost["threshold"],
            eventPeriod: eventPeriodVal
          }
          this.costsResponseData.push(costResponse);
        });
       });
      });
     }
   }
   mapNewQuoteForm(): WtUpdateQuoteRequest {
     let quoteRecord:  WtUpdateQuoteRequest;
     quoteRecord = {
      ProgramCode: "WEATHER",
      BrokerName: "8466",
      TransactionType: "ADD",
      TimeZoneOffset: "-05:00",
      Events: this.MapEvents(),
     };
     return quoteRecord;
   }
   MapEvents(): Events[]
   {
     let event: Events;
     let events: Events[] = [];
     event = {
       EventName: this.WUWRatingFormGroup.controls["eventName"].value,
       EventDays: this.mapEventDays(),
       Venue: this.MapVenue(),
       Coverages: this.MapCoverages()
     }
     events.push(event);
     return events;
   }
   mapEventDays() {
    let eventDays: EventDay[] = [];
    let eventDay: EventDay = {
      StartDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventstartdate0"].value),
      EndDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventenddate0"].value)
    };
    eventDays.push(eventDay);
    if(this.WUWRatingFormGroup.controls["eventstartdate1"].value !== null &&
      this.WUWRatingFormGroup.controls["eventstartdate1"].value !== "")
      {
        let eventDay1: EventDay = {
        StartDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventstartdate1"].value),
        EndDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventenddate1"].value)
        };
        eventDays.push(eventDay1);
      }
      if(this.WUWRatingFormGroup.controls["eventstartdate2"].value !== null &&
      this.WUWRatingFormGroup.controls["eventstartdate2"].value !== "")
      {
        let eventDay2: EventDay = {
        StartDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventstartdate2"].value),
        EndDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventenddate2"].value)
        };
        eventDays.push(eventDay2);
      }
      if(this.WUWRatingFormGroup.controls["eventstartdate3"].value !== null &&
      this.WUWRatingFormGroup.controls["eventstartdate3"].value !== "")
      {
        let eventDay3: EventDay = {
        StartDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventstartdate3"].value),
        EndDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventenddate3"].value)
        };
        eventDays.push(eventDay3);
      }
      if(this.WUWRatingFormGroup.controls["eventstartdate4"].value !== null &&
      this.WUWRatingFormGroup.controls["eventstartdate4"].value !== "")
      {
        let eventDay4: EventDay = {
        StartDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventstartdate4"].value),
        EndDateTime: this.dateTimetoISO(this.WUWRatingFormGroup.controls["eventenddate4"].value)
        };
        eventDays.push(eventDay4);
      }
      return eventDays;
   }

   dateTimetoISO(date: Date | string){
    const datetime = date instanceof Date
      ? moment(date)
      : moment(date, ["MM/DD/YYYY HH:00 A", "MM/DD/YYYY HH:mm A", moment.ISO_8601], true);

    if (!datetime.isValid()) {
      return "";
    }

    const normalizedUtc = moment.utc({
      year: datetime.year(),
      month: datetime.month(),
      day: datetime.date(),
      hour: datetime.hour(),
      minute: 0,
      second: 0,
      millisecond: 0
    });

    return normalizedUtc.toISOString().slice(0, 16);
   }

   MapVenue(){
     let venue: Venue;
     venue = {
      VenueName: this.WUWRatingFormGroup.controls["venuename"].value,
      StreetAddress: this.WUWRatingFormGroup.controls["streetaddress"].value,
      SuiteOrUnit: "",
      City: this.WUWRatingFormGroup.controls["city"].value,
      State: this.WUWRatingFormGroup.controls["state"].value,
      ZipCode: this.WUWRatingFormGroup.controls["zipcode"].value,
     }
     return venue;
   }
   MapCoverages(){
      let coverage: Coverages;
      let coverages: Coverages[] = [];
      coverage = {
        Peril: "Rain",
        Thresholds: this.MapThreshold(),
        Limits: this.MapLimits()
      }
      coverages.push(coverage);
      return coverages

   }
   MapThreshold()
   {
    let threshholds: number[]=[];
    this.thresholdConfigInfoFields.forEach((element: InputConfig) => {
       if(element.config.isHidden === false){
         let val = this.WUWRatingFormGroup.controls[element.fieldInfo.fieldName].value;
         if(val != undefined && val != null && val != "")
            threshholds.push(val);
       }
     });
     return threshholds;
   }
   MapLimits(){
    let limits: number[] =[];
    this.limitConfigInfoFields.forEach((element: InputConfig) => {
       if(element.config.isHidden === false){
         let val = this.WUWRatingFormGroup.controls[element.fieldInfo.fieldName].value;
         if(val != undefined && val != null && val != "")
          limits.push(val);
       }
     });
     return limits;
   }
}
